<template>
  <div class="page-header page-home">
    <div class="text">
      <div class="title">中国联通儿童个人信息保护政策及监护人须知</div>
      <div v-html="text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "unicomDeal4",
  data() {
    return {
      text: "",
    };
  },
  created() {
    this.text = `
    中国联通（以下简称“我们”）致力于保护使用我们产品或服务的儿童的个人信息。在《中国联通用户隐私政策》的基础上，我们希望通过《中国联通儿童个人信息保护政策及监护人须知》（以下简称“本须知”）向监护人（以下亦称“您”）和您监护的儿童（指未满 14 周岁的未成年 人，以下亦称“您的孩子”）说明我们在收集和使用儿童个人信息时对应 的处理规则等相关事宜。请在使用我们的产品或服务前务必仔细阅读并 透彻理解本须知，特别是以粗体标识的条款应重点阅读，在确认充分理 解并同意全部条款后再开始使用或允许您的孩子使用。
    本须知为在《中国联通用户隐私政策》基础上制定的特别规则，除另有约定外，本须知所用术语和缩略词与《中国联通用户隐私政策》中的术语和缩略词具有相同的涵义；与《中国联通用户隐私政策》如有不一致之处，以本须知为准；本须知未载明之处，则参照适用《中国联通用户隐私政策》。<span style="font-weight: 800;">为了维护儿童的合法权益，儿童应当在其监护人的指导下使用我们的服务。</span>
    <span style="font-weight: 800;">监护人特别说明：</span>
    您的理解和配合对我们保护您孩子的个人信息和隐私安全非常必要，为了维护您孩子的合法权益，我们希望您可以协助我们，确保您的孩子 在您的同意和指导下使用我们的产品或服务和向我们提交个人信息。我 们将根据本须知采取特殊措施保护我们获得的您孩子的个人信息。如果 您不同意本须知的内容，请您要求您的孩子立即停止访问/使用我们的产品或服务。
    <span style="font-weight: 800;">儿童特别说明：</span>
    <span style="font-weight: 800;">如果您未满 14 周岁，请务必通知您的监护人共同阅读本须知</span>，并在您使用我们的产品或服务、提交个人信息之前，寻求您的监护人的同意和指导。

    一、如何收集和使用儿童信息
    （一）在儿童使用我们的产品或服务过程中，我们会严格履行法律法规规定的儿童个人信息保护义务与责任，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则，在征得监护人的同意后收集和使用儿童个人信息。具体请查阅《中国联通用户隐私政策》“我们如何收集和使用您的个人信息”一节，详细了解我们收集和使用的儿童个人信息。
    （二）我们也会通过 Cookie 等同类技术自动收集您或您孩子的个人信息，具体请您查阅《中国联通用户隐私政策》“我们如何使用Cookie和同类技术”部分进行详细了解。
    （三）我们提供的与儿童有关的服务是不断发展的。如我们需要超出上述收集范围收集您或您监护的儿童的个人信息，我们将再次告知您，并征得您的同意。
    （四）根据相关法律法规规定，以下情形中收集儿童的信息无需征得儿童监护人的授权同意：
    1.为订立、履行与您或您的孩子的合同所必需；
    2.为履行法定职责或者法定义务所必需；
    3.为应对突发公共卫生事件，或者紧急情况下为保护儿童的生命健康和财产安全所必需；
    4.在合理的范围内处理您自行公开或者其他已经合法公开的个人信息；
    5.与国家安全、国防安全有关的；
    6.与公共安全、重大公共利益有关的；
    7.与犯罪侦查、起诉、审判和判决执行等有关的；
    8.用于维护所提供的产品或服务的安全稳定运行所必需，例如发现、处置产品或服务的故障；
    9.法律法规及监管政策规定的其他情形。
    <span style="font-weight: 800;">请您理解</span>，您可以选择是否填写或向我们提供特定的信息，但您如果不填写或提供某些特定的信息，将可能导致我们的产品或服务无法正常运行，或者无法达到我们拟达到的服务效果，您和您监护的儿童可能无法正常使用我们的产品、服务或相关的具体业务功能。

    <span style="font-weight: 800;">二、如何共享、转移和公开披露儿童信息</span>
    我们承诺对儿童个人信息进行严格保密，我们遵照法律法规的规定，严格限制共享、转移、披露儿童个人信息的情形，仅在《中国联通用户隐私政策》约定和您明确授权同意的情况下对外提供儿童信息。
    除了《中国联通用户隐私政策》“我们如何共享、转移、公开披露您的个人信息”部分所述的内容外，对于儿童个人信息，我们还将会采取如下措施来保护儿童个人信息在共享、转移和公开披露过程中的安全：
    （一）如果为了本须知所述目的而需要将儿童信息共享至第三方，
    我们会对受委托方及委托行为等进行安全评估，签署委托协议，要求受委托方的处理行为不得超出我们的授权范围。我们将评估该第三方收集儿童个人信息的合法性、正当性、必要性，并采用加密、匿名化、去标识化处理等手段保障您和儿童的信息安全。
    （二）我们将要求第三方对儿童个人信息采取保护措施，并且严格遵守相关法律法规与监管要求。我们会要求接收儿童个人信息的第三方遵守严格的保密义务及采取有效的保密措施，禁止其将这些儿童个人信息用于未经儿童及其监护人授权的用途，并要求受托公司依法履行以下义务：
    1.按照法律、行政法规的规定和我们的要求处理儿童个人信息；
    2.协助我们回应儿童监护人提出的申请；
    3.采取措施保障信息安全，并在发生儿童个人信息泄露安全事件时，及时向我们反馈；
    4.委托关系解除时及时删除儿童个人信息；
    5.不得转委托；
    6.其他依法应当履行的儿童个人信息保护义务。
    （三）我们会按照法律法规的要求征得您的同意，或确认第三方已经征得您同意。

    <span style="font-weight: 800;">三、如何储存儿童个人信息</span>
    <span style="font-weight: 800;">（一）我们在中华人民共和国境内收集和产生的儿童个人信息，将存储在中国境内。
    （二）我们会采取合理可行的措施，尽力避免收集和处理无关的儿童的个人信息。我们只会在达成本须知所述目的所需的期限内保留儿童的个人信息，除非法律有强制的留存要求。关于我们如何确定儿童个人信息存储期限请参见《中国联通用户隐私政策》“我们如何保护您的个人信息”。如我们终止服务或运营，我们将及时停止继续收集儿童个人信息的活动，同时会遵守相关法律法规要求提前向监护人通知，并在终止服务或运营后对儿童的个人信息进行删除或匿名化处理，但法律法规或监管部门另有规定的除外。</span>

    <span style="font-weight: 800;">四、如何保护儿童信息</span>
    我们非常重视儿童的隐私安全，并采取一切合理可行的措施，保护儿童个人信息：
    （一）我们会严格控制儿童个人信息的访问权限，对可能接触到儿童个人信息的工作人员采取最小够用授权原则，并采取技术措施对工作人员处理儿童个人信息的行为进行记录和管控，避免违法复制、下载儿童个人信息。
    （二）我们会定期组织内部相关人员进行培训，使其掌握岗位职责和应急处置策略和规程。在不幸发生儿童个人信息安全事件后，我们将按照法律法规的要求，及时向儿童及其监护人告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、儿童及其监护人可自主防范和降低风险的建议、对儿童及其监护人的补救措施等。我们将及时将事件相关情况以 App 推送通知、发送邮件/短消息等方式告知儿童及其监护人。难以逐一告知时，我们会采取合理、有效的方式发布相关警示信息。同时，我们还将按照监管部门要求，主动上报儿童个人信息安全事件的处置情况。若儿童及其监护人的合法权益受损，我们将承担相应的法律责任。
    （三）如您希望了解更多，请查阅《中国联通用户隐私政策》“我们如何保护您的个人信息”章节，详细了解我们如何采取了哪些措施保护儿童个人信息。
    
    <span style="font-weight: 800;">五、如何管理儿童信息</span>
    （一）为了您或您的孩子在使用我们的产品或服务期间可以更加便捷地访问和管理您孩子的个人信息，同时保障删除个人信息的权利，您和您的孩子可以按照《中国联通用户隐私政策》中的“您的权利”章节指引进行操作。
    （二）如存在以下情况，您和您监护的儿童可以请求我们删除收集、使用和处理的儿童个人信息。我们会在完成身份验证后，及时采取措施予以删除。
    1.若我们违反法律、行政法规的规定或者双方的约定收集、存储、使用、转移、披露儿童个人信息；
    2.若我们超出目的范围或者必要期限收集、存储、使用、转移、披露儿童个人信息；
    3.儿童监护人撤回同意；
    4.儿童或者其监护人通过注销等方式终止使用产品或者服务的。 但请注意，若您和被监护儿童要求我们删除特定儿童个人信息，可能导致该儿童无法继续使用我们的产品和服务或产品和服务中的某些具体业务功能。
    如您发现在未事先征得您同意的情况下收集了您监护儿童的个人信息，请及时联系我们，我们会设法尽快删除相关数据。

    <span style="font-weight: 800;">六、适用
    绝大多数情形下我们无法识别且不会判断收集和处理的个人信息是否属于儿童个人信息，我们将按照《中国联通用户隐私政策》收集和处理用户的个人信息。</span>

    <span style="font-weight: 800;">七、本须知的修订</span>
    基于为给您提供更好的服务的目的，我们可能会根据我们的产品或服务的更新情况及法律法规的相关要求适时修改本须知的条款，该等修改构成本须知的一部分，我们会在专门页面上展示最新修改版本。由于我们的用户较多，对于重大变更，我们还会提供更为显著的通知（包括在中国联通APP、中国联通官方网站发布公告的方式来通知您），具体详见《中国联通用户隐私政策》“本隐私政策如何更新”的规定。

    <span style="font-weight: 800;">八、如何联系我们</span>
    公司名称：中国联合网络通信有限公司
    注册地址：北京市西城区金融大街 21 号联通大厦联系电话：10010 客服热线
    相关负责人邮箱：hqs-yhys@chinaunicom.cn网站：http://www.10010.com
    如您对本须知或您和您孩子的个人信息的相关事宜有任何问题、投诉、意见或建议，您可前往中国联通当地营业厅、拨打 10010 客服热线、访问http://www.10010.com 网上营业厅、使用中国联通 APP 等多种方式
    与我们联系。一般情况下，我们将在十五个工作日内回复。
    本版发布日期：2022 年 1 月 15 日
    本版生效日期：2022 年 1 月 15 日`;
  },
};
</script>

<style lang="scss" scoped>
.page-home {
  width: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;

  .text {
    padding: 1rem;
    font-size: 1rem;
    line-height: 1.5rem;
    white-space: pre-wrap;
    .title {
      font-weight: 800;
      text-align: center;
      margin: 1rem auto;
    }
  }
}
</style>
